import { AppConstants } from "../constants/constants";
import { Organisation } from "./Organisation";

export interface Group {
    id: number;
    name: string;
    centreId: number;
    centreName: string;
    organisationId: number;
    organisationName: string;
}

export interface AddGroupDto {
    name: string;
    organisationId: number;
    centreId: number;
}

export interface GroupList {
  groupId: number;
  groupName: string;
  organisationName: string;
  centreName: string;
  learnerCount: number;
  tutorCount: number;
}

export interface GroupSelection {
  name: string;
  groups: Group[]
}

export interface UpdateGroupListDTO {
    searchFromList: string;
    filterByOrganisationName: string;
    filterByCentreName: string;
    sortGroup: string;
    sortOrganisation: string;
    sortTutorCount: string;
    sortLearnerCount: string;
    sortCentre: string;
    pageLength: number;
    pageIndex: number;
    organisation?: Organisation | -1;
    centre?: string | -1;
}

export interface UpdateGroupDto extends Group {
    addUsers: number[];
    removeUsers: number[];
}

export interface GroupEditResult {
  groupId: number;
  groupName: string;
  addedUsersCount: number;
  removedUsersCount: number;
}

export const INITIAL_UPDATE_GROUP_LIST_DTO: UpdateGroupListDTO = {
  searchFromList: AppConstants.BLANK,
  filterByCentreName: AppConstants.BLANK,
  filterByOrganisationName: AppConstants.BLANK,
  sortGroup: AppConstants.BLANK,
  sortOrganisation: AppConstants.BLANK,
  sortCentre: AppConstants.BLANK,
  sortLearnerCount: AppConstants.BLANK,
  sortTutorCount: AppConstants.BLANK,
  pageLength: 15,
  pageIndex: 0,
};

export class OrgCentreIdsDto {
  organisationIds: number[];
  centreIds: number[]
}